import { render, staticRenderFns } from "./SpinCarousel.vue?vue&type=template&id=04d3be2e"
import script from "./SpinCarousel.vue?vue&type=script&lang=js"
export * from "./SpinCarousel.vue?vue&type=script&lang=js"
import style0 from "./SpinCarousel.vue?vue&type=style&index=0&id=04d3be2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports